import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-stepper-icon',
  standalone: true,
  imports: [CommonModule],
  template: `
    <ng-container [ngSwitch]="name">
      <svg *ngSwitchCase="'check'" viewBox="0 0 14 14" aria-hidden="true">
        <path
          d="M11.667 3.5L5.25 9.917 2.333 7"
          fill="none"
          stroke="currentColor"
          stroke-width="1.6"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <svg *ngSwitchCase="'close'" viewBox="0 0 14 14" aria-hidden="true">
        <path
          d="M10.5 3.5 3.5 10.5M3.5 3.5l7 7"
          fill="none"
          stroke="currentColor"
          stroke-width="1.6"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </ng-container>
  `,
  styles: `
    :host {
      display: inline-flex;
      width: 14px;
      height: 14px;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }

    svg {
      width: 100%;
      height: 100%;
    }
  `,
})
export class StepperIconComponent {
  @Input({ required: true }) name: 'check' | 'close' = 'check';
}
